import { ClerkProvider } from "@clerk/react"
import type { ReactNode } from "react"

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as
  | string
  | undefined

export function AppProviders({ children }: { children: ReactNode }) {
  if (!clerkPublishableKey) {
    return <>{children}</>
  }

  return (
    <ClerkProvider
      publishableKey={clerkPublishableKey}
      telemetry={false}
      afterSignOutUrl="/login"
      signInFallbackRedirectUrl="/dashboard"
      signUpFallbackRedirectUrl="/dashboard"
    >
      {children}
    </ClerkProvider>
  )
}
